module.exports = "<span>\n  {{text}}\n</span>\n<div class=\"arrow\"></div>\n"